import React, { useState, useEffect } from "react";

// Regex to match emojis
const emojiRegex =
  /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;

const maxChars = 250;

const EmojiFreeTextarea = ({ inputValue, setInputValue, handleSend }) => {
  // const [text, setText] = useState("");

  // useEffect(() => {
  //   setInputValue(text);
  // }, [text]);

  // Handle input change (filter emojis & enforce character limit)
  const handleChange = (e) => {
    let newText = e.target.value.replace(emojiRegex, "");
    if (newText.length <= maxChars) {
      setInputValue(newText);
      // setInputValue("");
    }
  };

  // Prevent typing emojis & enforce character limit
  const handleKeyDown = (e) => {
    if (emojiRegex.test(e.key) || inputValue.length >= maxChars) {
      e.preventDefault();
    }

    if ((e.metaKey || e.ctrlKey) && e.key === "Enter") {
      e.preventDefault();
      handleSend();
    }
  };

  // Remove emojis from pasted content & enforce character limit
  const handlePaste = (e) => {
    e.preventDefault();
    let pastedText = e.clipboardData.getData("text").replace(emojiRegex, "");
    if (inputValue.length + pastedText.length <= maxChars) {
      setInputValue((prev) => prev + pastedText);
    } else {
      setInputValue(
        (prev) => prev + pastedText.slice(0, maxChars - prev.length)
      ); // Truncate pasted text
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
      }}
    >
      <textarea
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onPaste={handlePaste}
        style={{
          maxHeight: "calc(100% - 40px)",
          height: "calc(100% - 40px)",
          width: "calc(100% - 30px)",
          fontFamily: "Poppins",
          background: "#FFF",
          padding: "20px 16px",
          color: "var(--Grey, #666)",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "24px",
          letterSpacing: "0.16px",
          border: "none",
          overflow: "auto",
          outline: "none",
          boxShadow: "none",
          resize: "none",
          borderTopLeftRadius: "20px",
          borderBottomLeftRadius: "20px",
        }}
        type="text"
        placeholder="Send a message...."
        // value={text}
        value={inputValue}
      />
      <div
        style={{
          fontSize: "12px",
          paddingLeft: "16px",
          paddingBottom: "10px",
          color: "var(--Grey, #666)",
        }}
      >
        {inputValue.length}/{maxChars}
      </div>
    </div>
  );
};

export default EmojiFreeTextarea;
